// @flow
import { createAction, createReducer } from '@reduxjs/toolkit';
import axios from 'utils/axios';

// ACTIONS

export const initialState = createAction('users/initial');

export const findUserStarted = createAction('users/find_started');

export const findUserSucceeded = createAction('users/find_succeeded');

export const findUserFailed = createAction('users/find_failed');

export const fetchUsersStarted = createAction('users/fetch_started');

export const fetchUsersSucceeded = createAction('users/fetch_succeeded');

export const fetchUsersFailed = createAction('users/fetch_failed');

// ACTION_CREATORS

export function flushUserStore() {
  return async (dispatch: any) => {
    dispatch(initialState());
  };
}

export function findUserByEmail(email: string) {
  return async (dispatch: any) => {
    try {
      dispatch(findUserStarted());
      const result = await axios.get('/users/0', { params: { email } });
      dispatch(findUserSucceeded(result.data.user));
    } catch (e) {
      dispatch(findUserFailed(e));
    }
  };
}

export function fetchUsers(params: any = {}) {
  return async (dispatch: any) => {
    try {
      dispatch(fetchUsersStarted());
      const result = await axios.get('/users', { params });
      dispatch(fetchUsersSucceeded(result.data));
    } catch (exception) {
      dispatch(fetchUsersFailed());
    }
  };
}

// REDUCER
const INITIAL_STATE = {
  user: {},
  isFindingUser: false,
  isFailRequest: false,
  users: [],
  isFetchingUsers: false
};

export default createReducer(INITIAL_STATE, {
  [initialState]: state => {
    state.user = {};
    state.isFindingUser = false;
    state.isFailRequest = false;
    state.users = [];
  },
  [findUserStarted]: state => {
    state.isFindingUser = true;
    state.isFailRequest = false;
  },
  [findUserSucceeded]: (state, action) => {
    state.isFindingUser = false;
    state.user = action.payload;
  },
  [findUserFailed]: (state, action) => {
    state.isFindingUser = false;
    state.isFailRequest = true;
  },
  [fetchUsersStarted]: state => {
    state.isFetchingUsers = true;
  },
  [fetchUsersSucceeded]: (state, { payload: { users } }) => {
    state.users = users;
    state.isFetchingUsers = false;
  },
  [fetchUsersFailed]: state => {
    state.isFetchingUsers = false;
  }
});
